import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Login } from '../../shared/user.model';
import swal from 'sweetalert2';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  showLodingSpinner: boolean;
  formSubmitted: boolean;
  @Output() change = new EventEmitter();
  isLoginError: boolean = false;
  selectedItem: any;
  data: any;
  division: any = {};



  constructor(private userService: UserService, private router: Router) {
    this.formSubmitted = false;
    this.showLodingSpinner = false;
  }

  ngOnInit() {
    debugger;
    if (localStorage.getItem('accessToken') != null) {
      this.GetAllowedPages()
    }
  }

  Login(form: NgForm) {

    if (!form.invalid) {

      this.showLodingSpinner = true;
      this.userService.userAuthentication(form.value)
        .subscribe((data: any) => {
          this.showLodingSpinner = false;
          localStorage.setItem('accessToken', data.access_token);
          localStorage.setItem('userName', data.userName);
          localStorage.setItem('userRole', data.userRole);
          localStorage.removeItem('selectedMenu');
          this.getDivision(data.userName)
          this.GetAllowedPages();
        },
          (error) => {
            this.isLoginError = true;
            this.showLodingSpinner = false;
            if (error.status == 500 || error.status == 502) {
              swal('', "Internal Server Error, Please try later");
            }
            else
              swal('', error.error.error_description);
          });
    } else
      this.formSubmitted = true;
  }

  GetAllowedPages() {
    this.userService.getAllowedPages()
      .subscribe((data: any) => {
        localStorage.setItem('menuList', JSON.stringify(data));
        this.change.emit(false);
        if (data.length > 0)
          this.router.navigate([data[0].KM_Redirect_URL]);
      },
        (err: HttpErrorResponse) => {
        });
  }

  getDivision(userName) {
    this.data = this.userService.getDivisionId(userName);
    this.data.subscribe(
      (response: any) => {
        this.division = response;
        localStorage.setItem('divisonId', this.division.toString());
      }
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/registration/login/login.component.ts